<template>
    <div id="app" ref="andyapp">
        <div id="iconpackman-root" v-esddrop="{ fn: handleDrop }" class="root">
            <HeadComponent :version="version" :loaded="sheetData" :documents="docs" @toggleconsole="toggleConsole" @togglesidebar="toggleSidebar" @loadcomponentdata="loadComponentData" @loadiconpack="loadIconPack" />

            <InfoComponent :dark="darkMode" :sheetopen="sheetData !== ''" :dynamiccomponent="dynamicComponent" :dynamicdata="dynamicData" @loadcomponentdata="loadComponentData" />

            <div v-cloak class="flex-grid">
                <div ref="allowDeselect" class="allowDeselect content" :class="{mark: iconPack.iconsjson.length}" :disabled="!loading" @click.stop.prevent.self="handleSelection($event, false)">
                    <div class="CenteredContainer" @click.stop.prevent.self="handleSelection($event, false)">
                        <h3>Icon</h3>
                        <div>{{ iconPack.__sortState }}</div>
                        <img v-esddrop="setIconPackIcon" class="iconpack-icon" :src="iconPack.icon" :name="iconPack.icon.name" />
                    </div>

                    
                    <FilelistComponent
                        ref="filelist"
                        :icon-pack="iconPack"
                        :files="iconPack.icons"
                        :updated="updated"
                        @doRemoveFromAllIcons="doRemoveFromAllIcons"
                        @draggingchanged="draggingChanged"
                    />

                    <!-- <div class="CenteredContainer" :class="{mark: iconPack.iconsjson.length}">
                        <div v-if="!loading && !iconPack.icons.length" class="xxpackcheck">
                            <div class="logo">
                                <p class="infopackman"></p>
                            </div>
                            <p class="infotext">
                                Drag your icons and manifest onto this window....
                            </p>
                        </div>
                    </div> -->
                </div>

                <div v-show="sidebar" class="sidebar">
                    <div class="sidebarcontent">
                        <div class="CenteredContainer">
                            <h3>IconPack ID</h3>
                            <input
                                v-model.lazy="uid"
                                type="text"
                                class="iconpacku"
                                placeholder="e.g. com.yourname.youriconpack"
                                autocomplete="off"
                                data-1p-ignore
                                :readonly="uidExists"
                                @keydown="handleUidKeydown"
                            />
                            <div v-show="uidNeedsCheck" class="col left">
                                ID should be in the format:<div class="italic">com.yourname.youriconpack</div>
                            </div>
                            <div v-show="uidExists" class="col note">
                                <div class="bold">{{ uid }}</div> already exists in our system. Please make sure it is owned by you.
                            </div>
                        </div>

                        <JsonComponent name="manifest" :tableheadings="false" :rows="iconPack.manifest" :excludes="['_']" :namesmap="{'License': 'license'}" :typesmap="{'license': {nodetype: 'textarea'},'Description': {nodetype: 'textarea'}}" @input="updateManifest" />
                        <div v-if="iconPack.iconsjson.length" class="CenteredContainer">
                            <h3>Mapping</h3>
                            <div class="inputContainer">
                                <div class="col remove">
                                    <div class="remove-item" @click="doRemoveMapping()">×</div>
                                </div>
                                <span>Mapping file loaded.</span>
                            </div>
                        </div>

                        <JsonComponent v-if="dbgShowSettings" name="settings" :rows="state" :excludes="['_']" :typesmap="{'token': {type: 'password'}}" />

                        <div class="CenteredContainer">
                            <h3>Info</h3>
                            <div class="infomsg" :class="{gray: infoMsg==''}">{{ infoMsg }}</div>
                            <div class="duplicates content details">
                                <details v-show="duplicates.length" class="pad" @toggle="detailsOpened">
                                    <summary>Excluded files ({{ duplicates.length }} files)</summary>
                                </details>
                                <ul v-if="detailsOpen" class="details">
                                    <li v-for="(d,j) in duplicates" :key="j">
                                        <div>{{ d.fullPath || d.name }}</div>
                                        <div>(duplicate of {{ d.duplicate.fullPath || d.duplicate.name }})</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="moreaction">
                        <!-- <a href="./sample_iconpack.zip" download="sample_iconpack.zip">Download sample iconpack</a> -->
                        <button :disabled="loading || progress || iconPack.readOnly || iconPack.icons.length < 1" class="primary" @click="doExportIconPack">
                            Export IconPack
                        </button>
                        <div v-if="iconPack.readOnly">Exporting zipped iconPacks is not supported</div>
                    </div>
                    <img src="" class="testimage" style="max-width: 320px;" />
                </div> <!-- end sidebar-->
            </div><!-- end flexgrid-->

            <div v-cloak class="flex-grid testconsole" :class="{consoleVisible: showValidator}">
                <div class="widget widget__scrollable" style="display:flex;flex-direction: row;">
                    <span class="disclosure-triangle" @click="toggleConsole()"></span>
                    <div v-show="consoleOpen" ref="messageContainer" class="msg-container">
                        <div v-for="(msg,i) in dbgMessages" :key="i" class="msg">
                            <div class="topic" :class="{error: msg.err, caution: msg.caution}">{{ msg.topic }}</div>
                            <div class="time">{{ msg.timestamp }}</div>
                            <div v-if="msg.text.length" class="payload">{{ msg.text }}</div>
                        </div>
                    </div>
                </div> <!-- end widget widget__scrollable -->
                <!-- <div class="moreplaceholder"></div> -->
            </div><!-- end widget  -->
        </div>

        <div class="packcheck" :class="{hidden: !loading}">
            <div class="flexlogo">
                <div class="flexloader">&nbsp;</div>
                <div class="loader">
                    Loading...
                </div>
                <div class="infomsg">
                    {{ infoMsg }}
                </div>
                <div class="flexloader">&nbsp;</div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */

import "./css/index.css";
import { checkUID } from './js/checkUID.js';
import Utils, { dbgprintf } from "./js/utils";
import { CHECKUID_FORCE_LOWERCASE } from "./js/constants.js";
// import { startDragAndDropForElement } from "./js/ESDDrag.js";
// import JSZip, { file } from 'jszip';

import { readFileEntry } from "./js/ESDIconPackParser";
import { ESDIconPack } from "./js/ESDIconPack";
import {
    ValidateIconPack,
    EplFile_GetExtension,
    GetFolderContents,
    IsValidUUID
} from "./js/ESDValidateIconPack";
import { ValidateZippedIconPack } from './js/ESDValidateZippedIconPack.js';
import { ESDFileSelectorXX } from "./js/ESDFileSelector";
import { ESDImageScaler } from './js/ESDImageScaler.js';
// import * from  './js/ESDValidateIconPack';
// import * as EplFile_GetExtension from  './js/ESDValidateIconPack';
// require( './js/ESDValidateIconPack.js');
// import TestComponent from "./components/test-component";

import HeadComponent from "./components/head-component";
import InfoComponent from "./components/info-component";
import JsonComponent from "./components/json-component";
import FilelistComponent from "./components/filelist-component";
import MarkdownComponent from "./components/markdown-component";
// import { pushZippedFile } from "./js/loadSDIconPack.js";
import { dbgMessages } from "./js/dbgMessages.js";
window.dbgMessages = dbgMessages;

const MAllowedFileTypes = [ "png", "jpg", "jpeg", "svg", "gif" ];
const MTimeoutGuardMs = 4000;

const kStorageName = "iconpackman_settings";
import { version } from "./version.js";

export default {
    name: "App",
    components: {
        // HelloWorld,
        HeadComponent,
        JsonComponent,
        InfoComponent,
        FilelistComponent,
        // TestComponent
    },
    data() {
        return {
            dbgShowSettings: false,
            version,
            iconPack: this.createIconPack(),
            duplicates: [],
            allIcons: [],
            sidebar: true,
            detailsOpen: false,
            uid: '',
            infoMsg: '',
            sheetData: "",
            docs: [],
            config: null,
            state: {
                token: "",
                lastSaved: new Date().toLocaleTimeString()
            },
            dbgMessages,
            showValidator: false,
            consoleOpen: true,
            darkMode: true,
            dynamicComponent: null,
            dynamicData: null,
            loading: false,
            progress: false,
            updated: 0,
            timeoutGuard: null,
            uidExists: false,
            uidNeedsCheck: false,
        };
    },
    beforeMount() {
        dbgMessages.clear();
        const sttgs = localStorage.getObject(kStorageName);
        for(let s in sttgs) {
            this.state[ s ] = sttgs[ s ];
        }

        // const baseUrl = process.env.BASE_URL;
        // Utils.loadDataPromise(`${ baseUrl }/docs.json`).then(data => {
        Utils.loadDataPromise('./docs.json').then(data => {
            this.docs = JSON.parse(data);
        });

        // Load configuration
        Utils.loadDataPromise('./config.json').then(data => {
            this.config = JSON.parse(data);
        });
    },
    mounted() {
        window.app = this;
        window.utls = Utils;
        const time = new Date().getHours();
        const s = `Good ${time < 12 ? "Morning" : time < 18 ? "Afternoon" : "Evening"}`;
        dbgprintf(`Version: ${this.version}`);
        dbgprintf(`${s}... Drop your icons onto the window...`);

        // const arr = Object.entries(this.state);

        this.throttledUpdate = Utils.throttle((value, oldValue) => {
            console.log(
                "WATCHER::state changed... SAVING",
                Date.now(),
                value,
                oldValue
            );
            localStorage.setObject(kStorageName, this.state);
        }, 500);

        this.$watch(
            () => this.state,
            (value, oldValue) => {
                if(this.throttledUpdate) this.throttledUpdate(value, oldValue);
                // store.save();
            },
            { deep: true }
        );
    },
    watch: {
        uid(val) {
            const uid = this.$options.filters.removeSpecials(val);
            if(val !== this.iconPack.uid) {
                this.iconPack.uid = uid;
                this.uid = uid;
            }
            if (!this.uidExists) {
                this.verifyUid(uid);
                const isValid = IsValidUUID(this.uid);
                dbgprintf('%s is %s', this.uid, isValid ? 'valid' : 'invalid');
            }
        }
    },
    computed: {
        // previews: function() {
        //     if (!this.iconPack) return [];
        //     return this.iconPack ? this.iconPack.previews  : []
        // }
        previews: function() {
            return this.iconPack.previews ? this.iconPack.previews.filter(p => p.file) : 0;
        }
    },
    methods: {
        createTimeOutGuard() {
            this.timeoutGuard = Utils.debounce((fn) => {
                if(typeof fn === 'function') fn();
                console.log("TIMEOUT GUARD");
            }, MTimeoutGuardMs);
        },
        handleSelection(e, all) { // hack to deselect all
            if(this.$refs.filelist) {
                this.$refs.filelist.handleSelection(e, all);
            }
        },
        verifyUid(val) {
            // You can add your validation logic here.
            console.log('Verifying UID:', val);
            const uid = this.$options.filters.removeSpecials(val);
            if (val !== this.iconPack.uid) {
                this.iconPack.uid = uid;
                this.uid = uid;
            }
        },
        previewName(f) {
            if(!f) return '';
            return f.file ? f.file.name : f.name || '';
        },
        reset() {
            this.iconPack && this.iconPack.init();
            this.allIcons = [];
            // this.iconPack = new ESDIconPack();
            this.uid = "";
            this.duplicates = [];
            this.updated = 0;
        },
        createIconPack(options) {
            const iconPack = new ESDIconPack();
            if(options && options.readOnly) {
                iconPack.readOnly = true;
            }
            iconPack.on('thumbnailsLoaded', () => {
                // console.log("++++ Thumbnails loaded...");
                this.infoMsg = '';
                this.loading = false;
                this.progress = false;
            });
            iconPack.on('message', (obj) => {
                // console.log("++++ Message from iconPack:", obj);
                if(obj.message) this.infoMsg = obj.message;
                if(obj.loading != undefined) this.loading = obj.loading;
            });
            iconPack.on('uidChanged', async (uid) => {
                if(uid == '') {
                    this.uidExists = false;
                    return;
                }
                this.uidNeedsCheck = !IsValidUUID(uid);
                console.log("++++ UID changed in iconPack:", uid);
                const peek = (this.config && this.config.verifyUidUrl)
                    ? this.config.verifyUidUrl.replace('{UID}', uid)
                    : `https://mp-gateway.elgato.com/sdid-available?sdid=${uid}&extension=icons`;
                console.log("peek:", peek);
                try {
                    const response = await fetch(peek);
                    const result = await response.json();
                    this.uidExists = result && !result.available;
                    console.log("peeked:", result);
                } catch(err) {
                    console.error("Error fetching:", err);
                }
                // fetch(peek).then(r => r.json()).then(j => {
                //     console.log("peeked:", j);
                //     j && j.available ? this.uidExists = false : this.uidExists = true;
                // });
            });
            return iconPack;
        },
        dbgScrollToView() {
            if(this.lockMessages !== true) {
                if(this.$refs.messageContainer) {
                    this.$refs.messageContainer.scrollTop =
                        this.$refs.messageContainer.scrollHeight - 23;
                }
            }
        },
        doRemoveFromAllIcons(arrOrObj) {
            if(Array.isArray(arrOrObj)) {
                arrOrObj.map(f => {
                    const index = this.allIcons.indexOf(f);
                    if(index > -1) {
                        this.allIcons.splice(index, 1);
                    }
                });
            } else {
                const index = this.allIcons.indexOf(arrOrObj);
                if(index > -1) {
                    this.allIcons.splice(index, 1);
                }
            }
        },

        doRemoveMapping() {
            this.iconPack.iconsjson = [];
        },

        draggingChanged(val) {
            this.updated = Date.now();
            this.dragging = val;
        },
        setloading() {},
        detailsOpened(e) {
            this.detailsOpen = e.target.open;
        },

        openConsole(tof = true) {
            this.showValidator = tof;
        },

        toggleConsole(e) {
            this.showValidator = !this.showValidator;
        },

        toggleSidebar(e) {
            this.sidebar = !this.sidebar;
        },

        loadIconPack() {

            // const openFile = async => {
            //     console.log('openFile called...');
            //     window.showOpenFilePicker().then(([handle]) => {
            //         console.log('handle:', handle);
            //         const file = handle.getFile().then(file => {
            //             console.log('file:', file);
            //             const fold = file.getFile();
            //             console.log('fold:', fold);
            //         });
            //     });
            // };

            // openFile();


            const input = document.createElement('input');
            input.type = 'file';
            // input.accept = '.sdIconPack,.streamDeckIconPack,.zip'; // but we only support files (and not .sdIconPack) for now
            const accept = ['.streamDeckIconPack','.zip'];
            input.accept = accept.join(',');
            
            input.onchange = (event) => {
                const file = event.target.files[0];
                if (file) {
                    if (!accept.some(ext => file.name.endsWith(ext))) {
                        console.error(`File type not accepted. Allowed types: ${accept.join(', ')}`);
                        return;
                    }
                    this.handleDrop({ dataTransfer: { files: [file], items: [file] } });
                }
            };
            input.click();
        },

        handleDropFromComponent(evt, c) {
            this.handleDrop(evt, true);
        },

        handleDrop(evt, onlyMeta) {
            //  console.log("handleDrop...",evt.dataTransfer.files, evt.dataTransfer.items, {onlyMeta});
            let dataTransferFiles = evt.dataTransfer.files;
            if(!dataTransferFiles || !dataTransferFiles.length) return;
            dbgMessages.clear();

            dbgprintf("processing dropped items...");

            const getFileFromFileEntry = entry => {
                return new Promise(resolve => {
                    entry.file(file => {
                        // resolve(this.packageFile(file, entry));
                        // resolve(file, entry);
                        resolve({
                            file,
                            entry,
                            // name: file.name,
                            name: Utils.getFilenameWithLowerCaseExtension(file.name),
                            objectURL: URL.createObjectURL(file),
                            fullPath: `${entry.fullPath}`.slice(1)
                        });
                    });
                });
            };

            // let f = droppedFiles[0];
            // let f = evt.dataTransfer.items[ 0 ];
            let file = dataTransferFiles[ 0 ];
            // const entry = f.webkitGetAsEntry();
            // let entryTest = entry;
            const droppedFileName = file.name;
            const fileNameWithoutExtension = this.checkFile(droppedFileName).fileNameWithoutExtension;
            const extension = EplFile_GetExtension(droppedFileName).substr(1); // strip leading '.'

            const isPackedFile = extension.endsWith('sdIconPack') || extension.endsWith('streamDeckIconPack') || extension.endsWith('zip');
            if(!isPackedFile && Utils.hasUpperCase(extension)) {
                dbgprintf("Extension has uppercase characters: " + file.name);
            }

            const checkComplementaryIfGif = (icon, entries) => {
                const extension = EplFile_GetExtension(icon.name);
                const lowerCaseExtension = extension.substr(1).toLowerCase();
                if(lowerCaseExtension == "gif") {
                    const png = icon.name.replace(extension, ".png");
                    const found = entries.find(f => f.name.endsWith(png));
                    if(!found) {
                        dbgprintf(`Note: Complementary gif will be created for ${icon.name}`);
                    }
                    return found;
                }
            };

            let processed = false;
            if(!this.timeoutGuard) this.createTimeOutGuard();
            this.timeoutGuard(() => {
                this.infoMsg = "";
                this.loading = false;
                this.progress = false;
            });

            switch(extension) {
                case "zip":
                    console.log('dropped ZIP', file);
                    console.log('For now we only support zipped files, if they contain a full icon pack.');
                // const jsZip = new JSZip();
                // const zipOptions = { createFolders: true };
                // jsZip.loadAsync(file, zipOptions).then(zip => {
                //     console.log('ZIP', zip);
                // });
                // return jsZip.loadAsync(file, zipOptions).then(zip => {
                //     console.log('ZIP', zip);
                //     return zip;
                // });
                // break;
                case "streamDeckIconPack":
                    this.infoMsg = "loading...";
                    this.loading = true;
                    this.progress = true;
                    this.reset();

                    const pushZippedFile = (objectURL, name, inFile, createThumbnail = false, targetArray, entries) => {

                        // console.log("pushZippedFile", name, objectURL, inFile, createThumbnail, targetArray, entries);

                        const f = {
                            objectURL,
                            name,
                            fileName: Utils.getFilenameWithLowerCaseExtension(inFile.fileName || name),
                            fullPath: Utils.getFilenameWithLowerCaseExtension(inFile.name),
                            tags: Utils.tagify(inFile.tags),
                            file: {
                                fullPath: inFile.name,
                                name: inFile.fileName
                            },
                            zip: {
                                zippedFile: inFile
                            }
                        };

                        f.suffix = f.fileName.split(".").pop().toLowerCase();

                        if(f.suffix == "gif") {
                            const pngFileName = inFile.name.replace(/\.gif$/i, ".png");
                            const found = entries.find(e => e.name.endsWith(pngFileName));
                            createThumbnail = !found;

                            f.hasThumbnail = !!found;
                            f.thumbNail = "data:image/svg+xml,%3Csvg width='144' height='144' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23333336' d='M0 0h144v144H0z'/%3E%3Cg transform='translate(18 104)' fill='%23999999'%3E%3Ccircle cx='20' cy='10' r='6'/%3E%3Ccircle cx='54' cy='10' r='6'/%3E%3Ccircle cx='88' cy='10' r='6'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";

                            if(createThumbnail) {
                                const dbgMessageIndex = dbgprintf(`Creating complementary png for ${f.name}`);
                                const dbgMessage = dbgMessages[ dbgMessageIndex - 1 ];

                                if(objectURL.startsWith('blob:')) {
                                    f.hasThumbnail = true;
                                    const img = new Image();
                                    img.onload = () => {
                                        const canvas = document.createElement('canvas');
                                        const ctx = canvas.getContext('2d');
                                        const size = 144;
                                        if(size > 0) {
                                            canvas.width = size;
                                            canvas.height = size;

                                            const ratio = Math.min(size / img.width, size / img.height);
                                            const x = (size - img.width * ratio) / 2;
                                            const y = (size - img.height * ratio) / 2;
                                            ctx.drawImage(img, x, y, img.width * ratio, img.height * ratio);
                                        } else {
                                            canvas.width = img.width;
                                            canvas.height = img.height;
                                            ctx.drawImage(img, 0, 0);
                                        }

                                        // f.hasThumbnail = true;
                                        f.thumbNail = canvas.toDataURL('image/png');
                                        if(dbgMessage) dbgMessage.topic += ' => OK';
                                    };
                                    img.onerror = () => {
                                        f.hasThumbnail = false;
                                        if(dbgMessage) dbgMessage.topic += ' => ERROR';
                                    };
                                    img.src = objectURL;
                                } else {
                                    const l = new ESDImageScaler();
                                    l.loadAndScaleImage(objectURL).then(img => {
                                        f.hasThumbnail = true;
                                        f.thumbNail = img;
                                    }).catch(err => {
                                        f.hasThumbnail = false;
                                        // console.log('Error creating thumbnail', err);
                                        if(dbgMessage) dbgMessage.topic += ' => NOT OK';
                                    });
                                }
                            } else {
                                if(found) {
                                    f.zip.thumbNail = found;
                                    found.async("uint8array").then(content => {
                                        const blob = new Blob([ content ], { type: 'image/png' });
                                        f.thumbNail = URL.createObjectURL(blob);
                                        return inFile;
                                    });
                                }
                            }
                        }

                        if(targetArray) {
                            // targetArray.push(f);
                            this.iconPack.addPreview(f);
                        } else {
                            f.isSelected = false;
                            this.iconPack.addIcon(f);
                            // this.iconPack.icons.push(f);
                            // this.addIconToIconPack(f);
                        }
                    };

                    const ok = ValidateZippedIconPack(file).then(res => {

                        // console.log("ValidateZippedIconPack OK", file, res);

                        if(res.files.includes(undefined))
                            this.openConsole();

                        // this.iconPack = this.createIconPack({ readOnly: false });

                        this.uid = res.sdIconPackName ? res.sdIconPackName.replace(".sdIconPack", "") : "";

                        const loadFromZip = (fileName, toJson) => {
                            const found = res.files.find(f => f.name && f.name.endsWith(fileName));
                            if(!found) return Promise.resolve(toJson === true ? {} : '');
                            return found.async("text").then(content => {
                                return toJson && typeof content == "string"
                                    ? JSON.parse(content)
                                    : content;
                            });
                        };

                        const iconsJsonPromise = loadFromZip("icons.json", true).then(content => {
                            this.iconPack.iconsjson = content;
                            return content;
                        });

                        // find the icon
                        if(res.icon) {
                            const suffix = res.icon.name.split(".").pop();
                            if(suffix == "svg") {
                                // svg first, because it's in MAllowedFileTypes
                                res.icon.async("text").then(content => {
                                    const blob = new Blob([ content ], { type: "image/svg+xml" });
                                    this.iconPack.icon = URL.createObjectURL(
                                        blob
                                    );
                                });
                            } else if(MAllowedFileTypes.includes(suffix)) {
                                res.icon.async("base64").then(content => {
                                    this.iconPack.icon = `data:image/${suffix};base64, ${content}`;
                                });
                            }
                        }

                        loadFromZip("manifest.json", true).then(content => {
                            this.iconPack.setManifestFromJson(content);
                        });

                        loadFromZip("license.txt", false).then(content => {
                            this.iconPack.manifest.setLicenseText(content);
                        });

                        const loadZipEntry = (zip, contentType, mimeType, needsThumbnail = false, targetArray) => {
                            const name = zip._name ? zip._name : zip.name.split("/").pop();
                            zip.async(contentType).then(content => {
                                const blob = new Blob([ content ], { type: mimeType });
                                pushZippedFile(URL.createObjectURL(blob), name, zip, needsThumbnail, targetArray, res.icons);
                            });
                        };

                        // load previews
                        res.previews.forEach(zip => {
                            const suffix = zip.name.split(".").pop();
                            if(suffix == "svg") {
                                loadZipEntry(zip, "text", "image/svg+xml", false, this.iconPack.previews);
                            } else if(MAllowedFileTypes.includes(suffix)) {
                                loadZipEntry(zip, "uint8array", `image/${suffix}`, false, this.iconPack.previews);
                            }
                        });

                        // load icons
                        const loadIcons = () => {
                            console.log("----->> loadIcons...");

                            const arrGifs = res.icons.filter(f => f.name.endsWith('gif'));

                            // remove preview files (PNG) from the icons array
                            // but keep the files in the original array, because we need them
                            // later to create a thumbnail
                            const filteredIcons = [ ...res.icons ];
                            arrGifs.forEach(icon => {
                                const png = icon.name.replace(".gif", ".png");
                                const idx = filteredIcons.findIndex(e => e.name == png);
                                if(idx > -1) {
                                    filteredIcons.splice(idx, 1);
                                }
                            });

                            //  res.icons.forEach(i => {
                            filteredIcons.forEach(i => {
                                const suffix = i.name.split(".").pop().toLowerCase();
                                const name = i.name.split("/").pop();
                                i.fileName = name;
                                // load tags
                                const t = this.iconPack.iconsjson.find(i => i.path == name);
                                i.tags = t ? Utils.tagify(t.tags) : [];
                                if(t) {
                                    if(t.name !== "") i._name = t.name;
                                }

                                const needsThumbnail = suffix == "gif" ? res.orphanedGifs.includes(i) : false;
                                if(suffix == "gif") {
                                    // console.log( "GIF:", {name, needsThumbnail, orphanedGifs: res.orphanedGifs,  i });
                                }
                                if(suffix == "svg") {
                                    loadZipEntry(i, "text", "image/svg+xml");
                                } else if(MAllowedFileTypes.includes(suffix)) {
                                    loadZipEntry(i, "uint8array", `image/${suffix}`, needsThumbnail);
                                }
                            });

                        }; // end loadicons

                        const hasIconsJson = res.files.find(i => i.name.endsWith("icons.json"));
                        // we need a breath until icons.json is loaded
                        if(hasIconsJson) {
                            setTimeout(() => {
                                // console.log("----->> Promise:: icons json was loaded...");
                                iconsJsonPromise.then(loadIcons);
                            }, 100);
                        } else {
                            loadIcons();
                        }
                    })
                        .catch(err => console.log("ValidateZippedIconPack failed", err))
                        .finally(() => {
                            console.log("ValidateZippedIconPack.done...");
                            this.loading = false;
                        });
                    processed = true;
                    if(!ok) this.openConsole(true);
                    this.dbgScrollToView();
                    this.infoMsg = "";
                    break;

                /**
                 *  .sdIconPack
                 */

                case "sdIconPack":
                    this.reset();
                    let f = evt.dataTransfer.items[ 0 ];
                    // const objectURL = URL.createObjectURL(f);
                    // const objectURL2 = URL.createObjectURL(dataTransferFiles[ 0 ]);
                    // const x = ValidateIconPack(objectURL);
                    // const y = ValidateIconPack(objectURL2);
                    // console.log('dropped sdIconPack', f, f.getAsEntry);
                    const entry = f.webkitGetAsEntry ? f.webkitGetAsEntry() : f;
                    const res = ValidateIconPack(entry).then(
                        (success, checkedIcons) => {
                            dbgprintf(
                                success
                                    ? "Validation succeeded for  %s"
                                    : "Error while validating iconPack  %s",
                                entry.name,
                                !success
                            );
                            if(!success) {
                                this.openConsole();
                            }
                        }
                    ).then(() => {

                        // console.log('continue: ValidateIconPack', entry);

                        // Load sdIconPack
                        const newUID = checkUID(droppedFileName.replace(".sdIconPack", ''), CHECKUID_FORCE_LOWERCASE);
                        this.uid = newUID;
                        GetFolderContents(entry).then(folderEntries => {
                            // Load Manifest
                            const manifestJson = folderEntries.find(f => f.isFile && f.name == "manifest.json");
                            if(manifestJson) {
                                manifestJson.file(file => {
                                    this.iconPack.manifest
                                        .readFromFile(file)
                                        .then(data => {
                                            const ipIcon = folderEntries.find(f => f.isFile && f.name == data.Icon);
                                            if(!ipIcon) {
                                                const otherIcon = folderEntries.find(
                                                    f => f.isFile && /(png|jpg|jpeg|svg|tif|tiff|gif)$/gi.test(f.name)); // case insensitive
                                                if(otherIcon) {
                                                    dbgprintf("Note: iconPack icon was missing and got replaced by %s", otherIcon.name);
                                                    otherIcon.file(ofile => {
                                                        this.iconPack.setIcon(ofile);
                                                    });
                                                }
                                            } else {
                                                ipIcon.file(ofile => {
                                                    this.iconPack.setIcon(ofile);
                                                });
                                            }
                                            // license
                                            const ipLicense = folderEntries.find(f => f.isFile && f.name == data.License);
                                            if(ipLicense) {
                                                ipLicense.file(ofile => {
                                                    this.iconPack.manifest.license = ofile; // works also: this.iconPack.license = ofile;
                                                });
                                            }
                                        });
                                });
                            }

                            // Load Previews
                            const previewsFolder = folderEntries.find(f => f.isDirectory && f.name == "previews");
                            if(previewsFolder) {
                                GetFolderContents(previewsFolder, true).then(previewEntries => {
                                    const allP = previewEntries.map(getFileFromFileEntry);
                                    Promise.all(allP).then(p => {
                                        p.sort((a, b) => a.name.localeCompare(b.name));    // p.sort((a, b) =>  +/\d+/.exec(a.name)[0] - +/\d+/.exec(b.name)[0]);
                                        p.forEach(e => this.iconPack.addPreview(e));
                                    });
                                }
                                );
                            }

                            // Load icons.json
                            const iconsJson = folderEntries.find(f => f.isFile && f.name == "icons.json");
                            const iconsFolder = folderEntries.find(f => f.isDirectory && f.name == "icons");

                            // icons.json found
                            if(iconsJson && iconsFolder) {
                                readFileEntry(iconsJson)
                                    .then(ifstream => {
                                        return (ifstream &&
                                            ifstream.length &&
                                            ifstream) !== ""
                                            ? JSON.parse(ifstream) || []
                                            : [];
                                    })
                                    .then(iconsArray => {
                                        this.iconPack.iconsjson = iconsArray.map(item => ({
                                            ...item,
                                            path: Utils.getFilenameWithLowerCaseExtension(item.path),
                                            name: Utils.getFilenameWithLowerCaseExtension(item.name)
                                        }));
                                        // icons.json parsed -> should be of type Array
                                        GetFolderContents(iconsFolder, true).then(iconEntries => {
                                            iconsArray.forEach(e => {
                                                const icon = iconEntries.find(i => e.path == i.name);
                                                if(icon) {
                                                    const foundComplementaryPng = checkComplementaryIfGif(icon, iconEntries);
                                                    getFileFromFileEntry(icon).then(e => {
                                                        if(foundComplementaryPng) {
                                                            getFileFromFileEntry(foundComplementaryPng).then(c => {
                                                                e.thumbNail = c;
                                                                this.addIconToIconPack(e);
                                                            });
                                                        } else {
                                                            this.addIconToIconPack(e, true);
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                        );
                                    });
                            } else if(iconsFolder) {
                                // icons.json was not found
                                dbgprintf("Note: Icons.json was not found... adding everything in the 'icons' folder");
                                GetFolderContents(iconsFolder, true).then(iconEntries => {
                                    iconEntries.forEach(icon => {
                                        checkComplementaryIfGif(icon, iconEntries);
                                        getFileFromFileEntry(icon).then(e => {
                                            this.addIconToIconPack(e);
                                        }
                                        );
                                    });
                                }
                                );
                            }
                        });
                    }).catch(err => {
                        this.openConsole();
                    });
                    processed = true;
                    break;
                case "json":
                    if(file.name == "manifest.json") {
                        console.log(
                            "processFileTransfer: manifest....",
                            this.iconPack.manifest
                        );
                        this.iconPack.manifest.readFromFile(file);
                    } else if(file.name == "icons.json") {
                        console.log(
                            "processFileTransfer: icons.... ignoring...",
                            this.iconPack
                        );
                        this.iconPack.iconsjson = file;
                    }
                    processed = true;
                    break;
                case "txt":
                    if(file.name == "license.txt") {
                        this.iconPack.manifest.license = file;
                    }
                    processed = true;
                    break;
                default:
                    break;
            }

            if(processed) { 
                console.log("Done");
                return; 
            } else {
                console.log("Not processed");
            }

            const efs = new ESDFileSelectorXX({ debug: true });
            return efs.getDataTransferFiles(evt.dataTransfer, true).then(fileList => {
                console.log("got datatransfer files:", fileList);
                // searchMeta returns TRUE, if only a single file was dropped and this file was not a directory
                window.fileList = fileList;

                if(!searchMeta(fileList)) {
                    if(onlyMeta) {
                        // something was dropped on either the icon, or manifest pane...
                        return;
                    }
                    const hasDirs = fileList.find(f => f.isDirectory);
                    this.infoMsg = "loading...";
                    this.loading = hasDirs && hasDirs.length;

                    setTimeout(() => {
                        // we need some time to first read in the meta-files (if any)
                        processFileTransfer(fileList, msg => {
                            console.log("DONE processFileTransfer", msg);
                            dbgprintf("DONE", msg);
                            this.loading = false;
                            setTimeout(() => {
                                this.infoMsg = "";
                                 dbgprintf("");
                            }, 1000);
                        }, this);
                    }, 100);
                }
            });
        },
        isEditable(name) {
            return [ "fileName", "tags" ].includes(name);
        },

        checkFileType(dtFiles, arr = [ '.png', '.jpg' ], which = 'preview') {
            if(!dtFiles) return false;

           const isAllowedFileType = (f) => {
                return arr.some(s => f.name.toLowerCase().endsWith(s));
            };

            const found = !!Array.from(dtFiles).find(isAllowedFileType);
            if(!found) {
                let s = '';
                if(arr.length > 2) {
                    s = arr.join(', ').replace(/,([^,]*)$/, ' and $1');
                } else {
                    s = arr.join(' and ');
                }

                dbgprintf(`Only files of type ${s} are allowed as %s.`, which);
                this.openConsole();
                this.dbgScrollToView();
                return false;
            }
            return true;
        },

        setIconPackIcon(evt) {

            if(!this.checkFileType(evt.dataTransfer.files, [ '.png', '.jpg', '.svg' ], 'icon')) {
                return;
            }
            this.iconPack.setIconPackIcon(evt);
        },

        addIconPackPreview(evt, i) {

            if(evt.target.dataset && evt.target.dataset.index) {
                const to = Number(evt.target.dataset.index);
                let from = -1;
                const htmlString = evt.dataTransfer.getData('text/html');
                if(htmlString) {
                    const tempEl = Utils.stringToHTMLDiv(htmlString);
                    const imgEl = tempEl.querySelector('img');
                    if(imgEl) {
                        from = Number(imgEl.dataset.index);
                        if(from > -1) {
                            this.iconPack.swapPreviews(from, to);
                        }
                    }
                }
                if(from > -1) return;
            }

            if(!this.checkFileType(evt.dataTransfer.files)) {
                return;
            }

            const idx = Number(evt.target.dataset.index || 0);
            console.log("ippreview: addIconPackPreview: found index:", idx);
            const f = {
                objectURL: URL.createObjectURL(evt.dataTransfer.files[ 0 ]),
                file: evt.dataTransfer.files[ 0 ],
                name: evt.dataTransfer.files[ 0 ].name
            };

            this.iconPack.addPreview(f, idx);
        },

        doExportIconPack() {
            this.loading = true;
            this.infoMsg = "Preparing icon pack...";
            setTimeout(() => {
                // exportIconPack();
                this.iconPack.exportIconPack();
            }, 150);
        },

        sortDuplicates() {
            return this.duplicates.sort((a, b) => {
                return a.fileName > b.fileName;
            });
        },

        isFileAllowed(f, requiredMimeType = null) {
            if(f) {
                if(requiredMimeType && f.file) {
                    return f.file.type.startsWith(requiredMimeType);
                }
                return MAllowedFileTypes.includes(f.suffix.toLowerCase());
            }
            return false;
        },

        checkFile(s) {
            const f = {};
            const fa = s.split(".");
            f.suffix = fa.pop();
            f.fileName = fa.join(".");
            f.fileNameWithoutExtension = f.fileName;
            return f;
        },

        packageFile(f) {
            const fa = f.name.split(".");
            f.suffix = fa.pop().toLowerCase();
            f.fileName = fa.join(".");
            f.fileNameWithoutExtension = f.fileName;
            f.tags = "";
            f.imageinfo = "";
            f._status = { imageinfo: "", tips: {} };
            f.isSelected = false;
            f.isHidden = false;
        },

        checkDuplicate(f) {
            return !!this.allIcons.find(
                fl => fl.fileNameWithoutExtension == f.fileNameWithoutExtension
            );
        },

        addIconToIconPack(f, dontBlock = false) {
            if(!Utils.hasExtension(f.name)) {
                dbgprintf("No file-extension found for %s -> rejecting...", f.name);
                return;
            }

            const sanitizedFileName = Utils.getFilenameWithLowerCaseExtension(f.name);
            if(sanitizedFileName !== f.name) {
                const msg = `Renamed ${f.name} to ${sanitizedFileName}`;
                f.name = sanitizedFileName;
                this.openConsole();
                dbgprintf(msg);
                console.log(msg);
            }
            const nameParts = sanitizedFileName.split(".");

            f.suffix = nameParts.pop().toLowerCase();
            f.fileName = nameParts.join(".");
            f.fileNameWithoutExtension = f.fileName;
            f.tags = "";
            f.imageinfo = "";
            f._status = { imageinfo: "", tips: {} };
            f.isSelected = false;
            f.isHidden = false;

            if(this.isFileAllowed(f)) {
                if(!f.objectURL) f.objectURL = URL.createObjectURL(f.file);

                const suffixes = [ "png", "svg", "jpg", "jpeg", "tiff" ];
                const reservedNames = [ "icon", "cover", "thumbnail", "preview" ];
                const iconNames = suffixes.map(s => `icon.${s}`);
                // const coverNames = suffixes.map(s => `cover.${s}`);

                // const reservedNamesArray = reservedNames.map(e => suffixes.map(s => `${e}.${s}`)).join(",").split(",");
                // const reservedNamesArray = [].concat(
                //     ...reservedNames.map(e => suffixes.map(s => `${e}.${s}`))
                // );

                if(iconNames.includes(f.name.toLowerCase())) {
                    this.iconPack.setIcon(f.file);
                    return;
                }

                const existingDuplicate = this.allIcons.find(fl => fl.fileNameWithoutExtension == f.fileNameWithoutExtension ? fl : false);
                // this.allIcons.forEach(fl => {
                //     if(fl.fileNameWithoutExtension == f.fileNameWithoutExtension) { //} && fl.suffix.toLowerCase() == f.suffix.toLowerCase()) {
                //         console.log(">>> fl", fl.fileNameWithoutExtension, f.fileNameWithoutExtension, fl.suffix, f.suffix);
                //         console.log("---------> existingDuplicate", fl, f);
                //     }
                // });

                if(!existingDuplicate) {
                    if(f.suffix == "gif" && !f.thumbNail) {
                        dbgprintf(`Creating complementary png for ${f.name} .`);
                        f.thumbNail = "data:image/svg+xml,%3Csvg width='144' height='144' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23333336' d='M0 0h144v144H0z'/%3E%3Cg transform='translate(18 104)' fill='%23999999'%3E%3Ccircle cx='20' cy='10' r='6'/%3E%3Ccircle cx='54' cy='10' r='6'/%3E%3Ccircle cx='88' cy='10' r='6'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
                    }
                    this.allIcons.push(f);
                    if(dontBlock) {
                        this.iconPack.addIconT(f);
                    } else {
                        this.iconPack.addIcon(f);
                    }
                } else {
                    const duplicate = {...f, duplicate: existingDuplicate};
                    this.duplicates.push(duplicate);
                    console.log("duplicates", f.fileNameWithoutExtension, f.suffix, existingDuplicate.fileNameWithoutExtension, existingDuplicate.suffix);
                }
            }
        },

        tagClicked(t) {
            if(this.selectedTags.includes(t)) {
                const idx = this.selectedTags.indexOf(t);
                var removed = this.selectedTags.splice(idx, 1);
            } else {
                this.selectedTags.push(t);
            }
        },
        loadComponentData(componentData, obj) {
            const typ = typeof componentData;
            console.log("loadComponentData", componentData, obj, typ);

            if(typ === "boolean") {
                this.sheetData = "";
            } else if(typ === "string" && componentData.split(".").pop() == "md") {
                if(this.sheetData === componentData) {
                    this.sheetData = "";
                    return this.loadComponentData(false);
                }
                console.warn("LOADCOMPONENTDATA - INDEX.HTML --- ANDY REMOVE", componentData);
                Utils.loadDataPromise(componentData, false).then(data => {
                    this.setDynamicContent(MarkdownComponent, data);
                    this.sheetData = componentData;
                });
            }
        },
        setIconPackIcons(data) {
            this.setDynamicContent("minions-component", data);
        },
        setDynamicContent(componentName, data) {
            this.dynamicComponent = componentName;
            this.dynamicData = data;
        },
        updateManifest(updatedValues) {
            // Update the manifest properties with user-entered values
            Object.keys(updatedValues).forEach(key => {
                this.iconPack.manifest[key] = updatedValues[key];
            });
        },
        handleUidKeydown(event) {
            if (this.uidExists) {
                // Allow modifier keys themselves (Ctrl, Cmd, Shift, Alt)
                const modifierKeys = ['Control', 'Meta', 'Shift', 'Alt'];
                if (modifierKeys.includes(event.key)) {
                    return;
                }

                // Allow Ctrl/Cmd+C for copying, arrow keys, home, end, etc.
                const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'];
                const isCopyCommand = (event.ctrlKey || event.metaKey) && event.key === 'c';
                const isSelectAll = (event.ctrlKey || event.metaKey) && event.key === 'a';

                if (!allowedKeys.includes(event.key) && !isCopyCommand && !isSelectAll) {
                    event.preventDefault();
                    alert('This UID already exists in the system and cannot be modified.');
                    dbgprintf('This UID already exists in the system and cannot be modified.');
                }
            }
        }
    }
};

function searchMeta() {
    console.log("************ SEARCHMETA CALLED");
}

const e2 = new ESDFileSelectorXX({
    allowedFileTypes: [
        '.gif',
        '.pdf',
        '.png',
        '.jpg',
        '.jpeg',
        '.svg',
        '.tif',
        '.tiff',
        '.json'
    ],
    includeObjectUrl: true
});

const getDirectoryFromDirectoryEntry = (entry, dirName) => {
    return new Promise((resolve, reject) => {
        entry.getDirectory(dirName, {}, (dirEntry) => {
            resolve(dirEntry);
        }, (err) => {
            reject([]);
        });
        return entry;
    });
};

function processFileTransfer(fileList, _cb, me) {

    console.log("+++++ processFileTransfer", fileList);

    const xx = fileList.map(f => {

        // console.log("processFileTransfer___FILE:", f);

        if(!f.isDirectory && !f.suffix) {
            if(!Utils.hasExtension(f.name)) {
                dbgprintf("No file-extension found for %s -> rejecting...", f.name);
                return;
            }
            const fa = f.name.split(".");
            f.suffix = fa.pop();
        }

        if(f.file && f.suffix.toLowerCase() == 'json') {

            if(f.file.name == 'manifest.json') {
                // console.log("processFileTransfer: manifest....", app.manifest);
                app.iconPack.manifest.readFromFile(f.file);
            } else if(f.file.name == 'icons.json') {
                // console.log("processFileTransfer: icons.... ignoring...", app.iconPack);
                app.iconPack.iconsjson = f;
            }
        } else if(f.isDirectory) {

            let previewsFolder;

            if(f.name == 'previews') {
                return e2.getFolderContents(f).then((dirFileList, i) => {
                    dirFileList.forEach(p => {
                        me.iconPack.addPreview(p);
                    });
                    return dirFileList;
                });
            }

            const previewPromise = getDirectoryFromDirectoryEntry(f, 'previews').then(dirEntry => {
                return e2.getFolderContents(dirEntry).then((dirFileList, i) => {
                    dirFileList.forEach(p => {
                        me.iconPack.addPreview(p);
                    });
                    return dirFileList;
                });
            }).catch(err => {
                return [];
            });

            return previewPromise.then(previewFiles => {
                //    console.log('previewFiles', previewFiles);
                // const allP = e2.getFolderContents(f).then((dirFileList, i) => {
                return e2.getFolderContents(f).then((dirFileList, i) => {

                    // remove preview files from fileList
                    dirFileList = dirFileList.filter(e => !previewFiles.some(p => p.uid == e.uid));

                    const iconsjson = dirFileList.find(e => e.name.toLowerCase() === "icons.json");

                    const loadFileData = (file, responseType = 'json', obj = {}) => {
                        return Utils.fetchFile(file, responseType).then(data => {
                            obj.data = data;
                            return data;
                        });
                    };

                    if(iconsjson) {
                        console.log("******* ICONJSON FOUND", iconsjson);
                        loadFileData(iconsjson.file, 'json', iconsjson);
                    }

                    const manifestjson = dirFileList.find(e => e.name.toLowerCase() === "manifest.json");
                    if(manifestjson) {
                        loadFileData(manifestjson.file, 'json', manifestjson);
                    }

                    const license = dirFileList.find(e => e.name.toLowerCase() === "license.txt");
                    if(license) {
                        loadFileData(license.file, 'text', license);
                    }

                    const isIconRegex = new RegExp(`^icon.*\.(${Object.values(MAllowedFileTypes).join('|')})$`, 'gi');
                    const icon = dirFileList.find(e => isIconRegex.test(e.name.toLowerCase()));

                    // const previewsFolder = dirFileList.find(e => e.name.toLowerCase() === "previews");
                    const previews = dirFileList.filter(e => e.name.toLowerCase().startsWith('preview_'));
                    previews.forEach(p => {
                        me.iconPack.addPreview(p);
                        Utils.removeFromArray(dirFileList, p);
                    });


                    const fldrs = dirFileList.find(e => e.file.isDirectory);
                    console.log("++++++++ FOLDERS", fldrs);
                    window.dirFileList = dirFileList;

                    console.log("-----previewsFolder", previewsFolder);

                    const gifs = dirFileList.filter(e => e.name.split('.').pop().toLowerCase() === 'gif');

                    // if an icons.json file was in the dropped files, add it early to allow restoring of tags, curtom names, etc...
                    if(iconsjson) {
                        app.iconPack.iconsjson = iconsjson;
                    }

                    // remove meta-data
                    dirFileList = dirFileList.filter(e => e.name.toLowerCase() !== "icons.json");
                    dirFileList = dirFileList.filter(e => e.name.toLowerCase() !== "manifest.json");
                    // dirFileList = dirFileList.filter(e => e.name.split('.').pop().toLowerCase() !== 'gif');
                    dirFileList = dirFileList.filter(e => !e.name.toLowerCase().endsWith('.gif'));

                    // dirFileList = dirFileList.filter(e => e.name.toLowerCase() !== "previews");
                    // dirFileList = dirFileList.filter(e => !e.fullPath.startsWith('com.elgato.demoalltypes.sdIconPack/previews/'));


                    // first add found gifs to the icon pack, because they need additional thumnail pngs
                    gifs.forEach(f => {
                        app.addIconToIconPack(f);
                    });

                    dirFileList.forEach(f => {
                        app.addIconToIconPack(f);
                    });

                    if(manifestjson) {
                        app.iconPack.manifest.readFromFile(manifestjson);
                    }
                    if(license) {
                        // console.log('adding license', license);
                        app.iconPack.manifest.license = license;
                    }

                    app.sortDuplicates();
                    // console.log("processFileTransfer:getFolderContents::DONE", Date.now() - tt);

                    if(_cb) _cb(dirFileList);

                    /* END getFolderContents*/

                    // console.dir({ icon, iconsjson, manifestjson, license, previewsFolder, previews });


                    return { icon, iconsjson, manifestjson, license, gifs, previews, previewsFolder };

                }).then(d => {
                    console.log("++++++++++ **** ALL LOADED ****", d);
                });
            });

            return allP;

            // });  //end readEntries
        } else { //check single files
            if(MAllowedFileTypes.includes(f.suffix.toLowerCase())) {
                app.addIconToIconPack(f);
                return Promise.resolve(f);
            }
            return Promise.resolve(null);
        }
    });

    if(_cb) _cb(fileList);

}
</script>